import { PplxError } from '#pplx/frontend/common/errors.js';
export class AuthError extends PplxError {
    name = 'AuthError';
}
//# sourceMappingURL=errors.js.map